import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=ccb9c426&"
import script from "./PostCard.vue?vue&type=script&lang=js&"
export * from "./PostCard.vue?vue&type=script&lang=js&"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=ccb9c426&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports